import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col, CardBody, Card } from "reactstrap";
import Tabs, { TabPane } from "rc-tabs";
import TabContent from "rc-tabs/lib/SwipeableTabContent";
import ScrollableInkTabBar from "rc-tabs/lib/ScrollableInkTabBar";

import BusinessService from "./Businesses.service.js";
import AuthService from "../Authentication/auth.service.js";
import Alerts from "../../components/Alerts/alerts.js";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";

import TabGenralPatient from "./TabGenralPatient";
import AppAddresses from "./AppAddresses";
import FamilyMembers from "./FamilyMembers";
import AccountCredentialActions from "../../components/AccountCredentials/AccountCredentialActions";
import { SensitivePageBanner } from "../../context/SensitiveInfoContext";

const PatientDetails = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('1');
    const [loading, setLoading] = useState(false);
    const { id } = useParams();

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    

    return (
        <div className="app-main__outer">
            <div className="app-main__inner">
                <div className="bg-light-gray bg-animation">
                    <div className="d-flex justify-content-center align-items-center">
                        <Col md="12" className="mx-auto app-login-box">
                            <div className="app-page-title">
                                <div className="page-title-wrapper">
                                    <div className="page-title-heading fw-bold">
                                        <div className="page-title-icon">
                                            <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
                                        </div>
                                        <div>
                                            {`${t("Patient")} ${t("Management")}`}
                                            <div className="page-title-subheading">
                                                {`${t("Details of")} ${t("Patient")}`}.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="page-title-actions">
                                        <AccountCredentialActions accountType="patient" accountId={id} />
                                        <NavLink to="/patients-list">
                                            <button type="button" className="btn btn-outline-success btn-hover-shine me-3">
                                                {t("Back")}
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center">
                                <div className="col-md-12">
                                    <LoadingOverlay 
                                        tag="div" 
                                        active={loading}
                                        styles={{ overlay: (base) => ({ ...base }) }}
                                        spinner={<DNALoader />}
                                    >
                                        <SensitivePageBanner />
                                        <Tabs
                                            activeKey={activeTab}
                                            onChange={handleTabChange}
                                            renderTabBar={() => (
                                                <ScrollableInkTabBar
                                                    extraContent={<div style={{ width: 50 }}></div>}
                                                    scrollAnimated={true}
                                                />
                                            )}
                                            renderTabContent={() => <TabContent animated={false} />}
                                        >
                                            <TabPane tab={t('General')} key="1">
                                                <TabGenralPatient className="btn-custom-color" business_id={id} />
                                            </TabPane>

                                            <TabPane tab={t('App Addresses')} key="2">
                                                <Card>
                                                    <CardBody>
                                                        <AppAddresses patient_id={id} />
                                                    </CardBody>
                                                </Card>
                                            </TabPane>


                                            <TabPane tab={t('Family Members')} key="3">
                                                <Card>
                                                    <CardBody>
                                                        <FamilyMembers patient_id={id} />
                                                    </CardBody>
                                                </Card>
                                            </TabPane>


                                            
                                        </Tabs>
                                    </LoadingOverlay>
                                </div>
                            </div>
                        </Col>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientDetails;